import React from "react";

import Collapsible from "./Collapsible";

const ChecklistSidebar = ({ stateData, selectedBrandDemographics, selectedGols, disabledButton }) => (
  <div className="checklist-sidebar">
    <h2>Promotion Checklist</h2>
    {!stateData?.firstName &&
      !stateData?.lastName &&
      !stateData?.email &&
      !stateData?.company &&
      !stateData?.country &&
      !stateData?.promotionDate &&
      !stateData?.notes &&
      selectedBrandDemographics.filter((demo) => demo.brandDemos.length > 0).length < 1 &&
      selectedGols.length === 0 && <p>As you fill in the form, this checklist will populate.</p>}
    <div>
      {(stateData?.firstName ||
        stateData?.lastName ||
        stateData?.email ||
        stateData?.company ||
        stateData?.country) && (
        <Collapsible title={<ChecklistSidebarDataTitle title="Your Information" />}>
          {stateData?.firstName && <ChecklistSidebarDataWithLabel label="First Name" data={stateData.firstName} />}
          {stateData?.lastName && <ChecklistSidebarDataWithLabel label="Last Name" data={stateData.lastName} />}
          {stateData?.email && <ChecklistSidebarDataWithLabel label="Email" data={stateData.email} />}
          {stateData?.company && <ChecklistSidebarDataWithLabel label="Company" data={stateData.company} />}
          {stateData?.country && <ChecklistSidebarDataWithLabel label="Country" data={stateData.country} />}
        </Collapsible>
      )}

      {(stateData?.promotionDate || stateData?.notes) && (
        <Collapsible title={<ChecklistSidebarDataTitle title="Promotion Details" />}>
          {stateData?.promotionDate && (
            <ChecklistSidebarDataWithLabel label="Target Promotion Date" data={stateData.promotionDate} />
          )}
          {stateData?.notes && <ChecklistSidebarDataWithLabel label="Notes" data={stateData.notes} />}
        </Collapsible>
      )}

      {selectedBrandDemographics.filter((demo) => demo.brandDemos.length > 0).length > 0 && (
        <>
          {selectedBrandDemographics
            .filter((demo) => demo.brandDemos.length > 0)
            .map((data) => (
              <Collapsible key={data.name} title={<ChecklistSidebarDataTitle title={`${data.name} Targeting`} />}>
                {data.brandDemos.map((demo) => (
                  <ChecklistSidebarData data={demo.name} key={demo.name} />
                ))}
              </Collapsible>
            ))}
        </>
      )}

      {selectedGols.length > 0 && (
        <Collapsible title={<ChecklistSidebarDataTitle title="Interest Areas" />}>
          {selectedGols.map((data) => (
            <ChecklistSidebarData data={data.name} key={data.name} />
          ))}
        </Collapsible>
      )}
    </div>
    <button className="checklist-submit-btn" type="submit" disabled={disabledButton}>
      <i className="fa-regular fa-inbox-full" />
      Send Checklist
    </button>
  </div>
);

const ChecklistSidebarDataTitle = ({ title }) => (
  <div>
    <h3 className="checklist-sidebar-data-title">{title}</h3>
  </div>
);

const ChecklistSidebarDataWithLabel = ({ label, data }) => (
  <p>
    {label && ` ${label}: `} <b>{data}</b>
  </p>
);
const ChecklistSidebarData = ({ data }) => <b className="checklist-sidebar-data-item">{data}</b>;

export default ChecklistSidebar;
